export default function (parms = {}) {
  const { xData = [], yData = [] } = parms
  const options = {
    tooltip: {
      show: true
    },
    legend: {
      show: true,
      left: 10
    },
    grid: {
      top: 50,
      bottom: 35,
      left: 40,
      right: 20
    },
    yAxis: {
      axisLine: {
        show: true,
        lineStyle: {
          color: '#DCDFE6'
        }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#909399'
      },
      splitLine: {
        lineStyle: {
          color: '#EEF0F5'
        }
      }
    },
    xAxis: {
      data: xData,
      axisLine: {
        lineStyle: {
          color: '#DCDFE6'
        }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#909399'
      },
      axisPointer: {
        show: true
      }
    },
    series: {
      type: 'line',
      name: '活跃量',
      data: yData,
      lineStyle: {
        color: '#3473E6',
        shadowColor: 'rgba(52, 115, 230, 0.2)',
        shadowBlur: 2,
        shadowOffsetY: 13
      },
      itemStyle: {
        color: '#3473E6'
      }
    }
  }

  return options
}
